import { t } from "i18next";
import React from "react";

const ArrayIndex = ({
  label,
  data,
  onChangeValue,
  type,
  value,
  valType,
  index,
}) => {
  const onChange = (val) => {
    onChangeValue(type, val);
  };

  return (
    <div className="flex flex-row justify-between w-full p-6">
      <h1 className="w-1/4">{label}</h1>
      <div className="flex flex-wrap justify-between w-3/5">
        {data.map((dt, i) => {
          return (
            <h1
              key={i}
              onClick={onChange.bind(this, dt[`${index}`])}
              className={`cursor-pointer ${
                valType == 1
                  ? value == dt[`${index}`]
                    ? "bg-mainAqwaBlue opacity-100 text-white"
                    : "bg-whiteCardColor"
                  : value?.includes(dt[`${index}`])
                  ? "bg-mainAqwaBlue opacity-100 text-white"
                  : "bg-whiteCardColor"
              } p-2 px-4 font-medium opacity-50 mt-1`}
            >
              {t(dt.label||dt.name)}
            </h1>
          );
        })}
      </div>
    </div>
  );
};

export default ArrayIndex;
